module.exports = __webpack_public_path__ + "static/media/DetailedLogo.6c5867f8.png";